import type { CupidCard, CardDisplayStatus } from "../pages/Dashboard/types/dashboard";
import { parseKSTDate } from "./dateUtils";

export function getCardDisplayStatus(
  card: Pick<CupidCard, "status" | "expiresAt" | "extendDeadlineAt" | "extendCount">,
  now: Date = new Date()
): CardDisplayStatus {
  const expiresAt = parseKSTDate(card.expiresAt);
  const extendDeadlineAt = parseKSTDate(card.extendDeadlineAt);
  const nowMs = now.getTime();

  if (nowMs >= extendDeadlineAt.getTime()) return "DEAD";
  if (nowMs >= expiresAt.getTime() && card.extendCount >= 1) return "DEAD";
  if (nowMs >= expiresAt.getTime() && card.extendCount < 1) return "EXPIRED_EXTENDABLE";
  if (card.status === "OPENED") return "OPENED";
  return "LOCKED";
}

export function shouldRenderCard(
  card: Pick<CupidCard, "status" | "expiresAt" | "extendDeadlineAt" | "extendCount">,
  now: Date = new Date()
): boolean {
  return getCardDisplayStatus(card, now) !== "DEAD";
}

export function canShowExtendButton(
  card: Pick<CupidCard, "status" | "expiresAt" | "extendDeadlineAt" | "extendCount" | "isExtendable">,
  now: Date = new Date()
): boolean {
  const displayStatus = getCardDisplayStatus(card, now);
  if (displayStatus === "DEAD") return false;
  if (card.extendCount >= 1) return false;
  return card.isExtendable;
}

export function msUntilExpiry(expiresAt: string, now: Date = new Date()): number {
  return Math.max(0, parseKSTDate(expiresAt).getTime() - now.getTime());
}

export function msUntilExtendDeadline(extendDeadlineAt: string, now: Date = new Date()): number {
  return Math.max(0, parseKSTDate(extendDeadlineAt).getTime() - now.getTime());
}

/** expiresAt까지 남은 ms를 디자인 스펙(Math.ceil, 4단계)에 따라 변환 */
export function formatRemainingTime(ms: number): string {
  if (ms <= 0) return "만료됨";
  const hours = ms / (1000 * 60 * 60);
  if (hours < 1) return "곧 만료";
  if (hours < 12) return `${Math.ceil(hours)}시간 남음`;
  if (hours <= 24) return "오늘 마감";
  const days = Math.ceil(hours / 24);
  return `${days}일 남음`;
}

export function formatCountdown(ms: number): string {
  if (ms <= 0) return "만료됨";
  const totalSeconds = Math.floor(ms / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (days > 0) return `${days}일 ${hours}시간 ${minutes}분`;
  if (hours > 0) return `${hours}시간 ${minutes}분`;
  return `${minutes}분 ${seconds}초`;
}
